var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Heritage_Home",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 58,
    height: 48,
    viewBox: "0 0 810 670",
    style: {
      enableBackground: "new 0 0 810 670"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DD1C23;}\n\t.st1{fill:#004879;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M784.2,542.5c-19.9-17.6-40.5-27.3-59.7-35.2c-47.4-19.4-99.4-30-158.9-32.4c-99.9-4.1-201.2,12.9-318.9,53.5 c-23,7.9-46.9,14.2-70.8,18.5c-19.1,3.5-38.5,5.6-57.9,6.5l-9.5,0.2v113.3c0,0,26.3,0.2,40.6,0c4.7-0.1,9.4-0.1,14.1-0.3 c29.4-1.4,59.2-6,91.4-14.1c52.1-13.2,101.6-33.5,147.8-53.3c62.1-26.5,125.8-43.8,189.3-51.5c27-3.3,54.2-5.2,81.4-5.5 c27.2-0.4,54.4,0.8,81.4,3.7c12.8,1.4,25.6,3,38.4,4.3L784.2,542.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.5,504.1c11.6-2.1,23.1-4.7,34.6-7.8V241.7l202-132.8l202.5,129.5v196.1c33.6,3.6,65.1,9.9,95,19.1l0-12 l-0.3-152.6l77.8,0c11.4,0,20.8-7,24-18c3.2-10.9-0.9-21.9-10.5-28L428.3,9.8c-14.1-9-32.4-9-46.6,0L16.6,243v0 C7,249.1,2.9,260.1,6.1,271c3.2,10.9,12.6,18,24,18l78.5,0l-0.2,221.2l8.2-0.2C134,509.2,151.4,507.3,168.5,504.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M740,576c-2.2-0.8-3.9-1.5-4.9-2.2c-1-0.6-1.8-1.3-2.2-2.1c-0.4-0.7-0.6-1.7-0.6-2.9c0-1.6,0.6-2.8,1.7-3.7 c1.2-0.9,2.8-1.3,5-1.3c2.7,0,5.6,0.6,8.5,1.8l0.3,0.1l1.5-4.3l-0.3-0.1c-3-1.3-6.4-2-10-2c-3.5,0-6.3,0.8-8.4,2.5 c-2.2,1.7-3.2,4-3.2,6.9c0,2.7,0.8,4.9,2.2,6.6c1.5,1.7,3.9,3.1,7.3,4.3c2.3,0.8,4.1,1.6,5.3,2.3c1.1,0.6,1.9,1.3,2.4,2.1 c0.5,0.7,0.7,1.7,0.7,2.9c0,1.8-0.6,3.1-2,4.1c-1.3,1-3.4,1.5-6.1,1.5c-1.7,0-3.4-0.2-5.1-0.5c-1.7-0.4-3.3-0.8-4.7-1.4l-0.5-0.2 v4.8l0.2,0.1c2.3,1.1,5.7,1.7,9.9,1.7c4,0,7.2-0.9,9.5-2.7c2.4-1.8,3.6-4.4,3.6-7.6c0-2.5-0.7-4.6-2.2-6.2 C746.4,578.9,743.8,577.4,740,576z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M786,560l-11.3,29.2L763.5,560h-6.9v36.5h4.5v-23.1c0-2.7-0.1-5.1-0.2-7.2l11.6,30.3h3.8l11.7-30.4 c-0.2,2.5-0.2,4.8-0.2,6.9v23.4h4.9V560H786z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.97e0a1dbd4925f5af2eda06f6c9b7082.svg";
export { ForwardRef as ReactComponent };